import { AlertColor } from "@mui/material";

import AlertBanner from "@rui/AlertBanner";

interface ISiteStatusBanner {
  severity?: AlertColor;
  text?: string;
}
const SiteStatusBanner = ({
  severity = "warning",
  text = "Service Error",
}: ISiteStatusBanner) => {
  return <AlertBanner severity={severity}>{text}</AlertBanner>;
};

export default SiteStatusBanner;
